/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

import BSMenuItem from "react-bootstrap/MenuItem";
import BSNavDropdown from "react-bootstrap/NavDropdown";
import FAIcon from "react-fa/Icon";
import PropTypes from "prop-types";
import React, {Component} from "react";

export default class NavLanguagePicker extends Component {
  render() {
    const {
      languages,
      sessionLanguage,
    } = this.props;

    return (
      <BSNavDropdown
        id="menu-language-picker"
        title={
          <span>
            <FAIcon name="globe" /> {languages[sessionLanguage]}
          </span>
        }
      >
        {Object.keys(languages).map(
          language => ((language !== sessionLanguage) ? (
            <BSMenuItem
              href={`?lang=${language}`}
              key={language}
            >
              {languages[language]}
            </BSMenuItem>
          ) : null),
        )}
      </BSNavDropdown>
    );
  }
}



// WEBPACK FOOTER //
// ../render/components/NavLanguagePicker.jsx